import { z } from "zod";

export const customEntitySecondaryOwnerSchema = z.object({
  type: z.literal("user"),
  id: z.string().uuid(),
});

export const customEntityOwnerSchema = z.object({
  type: z.string(),
  id: z.string().uuid(),
  secondary_owners: z.array(customEntitySecondaryOwnerSchema).optional(),
});

export type CustomEntityOwner = z.infer<typeof customEntityOwnerSchema>;
